import { SvgIcon, Tooltip, Zoom } from '@mui/material';

import { SvgIconType } from '@/features/shared/types';

import { stylesFormalitiesFormErrorIcon } from './AlertTooltip.styles';

type AlertTooltipProps = {
  color?: string;
  message?: React.ReactNode;
  backgroundColor?: string;
  icon: {
    color: string;
    svg: SvgIconType;
  };
};

export const AlertTooltip: React.FunctionComponent<AlertTooltipProps> = ({ message, color, backgroundColor, icon }) => (
  <Tooltip
    title={message}
    TransitionComponent={Zoom}
    placement='top'
    PopperProps={{
      sx: {
        '& .MuiTooltip-tooltip': {
          border: 1,
          borderColor: 'currentColor',
          color,
          backgroundColor,
          width: '1000px',
        },
      },
    }}
  >
    <SvgIcon component={icon.svg} sx={{ ...stylesFormalitiesFormErrorIcon, color: icon.color }} />
  </Tooltip>
);
